(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[28,184],{

/***/ "LNcM":
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function(window, document) {
'use strict';


// Exits early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }
  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}(window, document));


/***/ }),

/***/ "Tskq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("b0gt");


/***/ }),

/***/ "UXOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ NavTag_NavTag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/nav-tag/NavTag.themes.js




var NavTag_themes_themes = function themes(_ref) {
  var _classnames, _classnames2;

  var _ref$colorActive = _ref.colorActive,
      colorActive = _ref$colorActive === void 0 ? colors["a" /* COLORS */].LIGHT_SAND : _ref$colorActive,
      _ref$colorUnactive = _ref.colorUnactive,
      colorUnactive = _ref$colorUnactive === void 0 ? colors["a" /* COLORS */].SAND : _ref$colorUnactive,
      isActive = _ref.isActive;
  return {
    "default": {
      thRoot: classnames_default()('block border font-bold items-stretch px-20 py-10 rounded-pill text-12 text-black text-sans transition-colors duration-250 ease-in whitespace-nowrap', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(colorActive, " border-").concat(colorActive), isActive), Object(defineProperty["a" /* default */])(_classnames, "bg-transparent border-".concat(colorUnactive, " hocus:bg-").concat(colorActive, " hocus:border-").concat(colorActive), !isActive), _classnames))
    },
    reverse: {
      thRoot: classnames_default()('block border font-bold items-stretch px-20 py-10 rounded-pill text-12 text-sans transition-colors duration-250 ease-in whitespace-nowrap', (_classnames2 = {}, Object(defineProperty["a" /* default */])(_classnames2, "bg-".concat(colorActive, " border-").concat(colorActive, " text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][colorActive]), isActive), Object(defineProperty["a" /* default */])(_classnames2, "bg-".concat(colorUnactive, " border-").concat(colorUnactive, " text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][colorUnactive], " hocus:bg-").concat(colorActive, " hocus:border-").concat(colorActive, " hocus:text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][colorActive]), !isActive), _classnames2))
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/nav-tag/NavTag.jsx




var __jsx = react_default.a.createElement;




var NavTag_NavTag = function NavTag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      colorActive = _ref.colorActive,
      colorUnactive = _ref.colorUnactive,
      href = _ref.href,
      isActive = _ref.isActive,
      _onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$trackingData = _ref.trackingData,
      trackingData = _ref$trackingData === void 0 ? {} : _ref$trackingData,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "colorActive", "colorUnactive", "href", "isActive", "onClick", "theme", "trackingData"]);

  var tracker = Object(useTracking["a" /* useTracking */])();
  var track = !isEmpty_default()(trackingData) && _onClick ? function () {
    return tracker(trackingData);
  } : noop_default.a;

  if (!react["Children"].count(children)) {
    return null;
  }

  var TagName = 'div';

  if (href) {
    TagName = 'a';
  } else if (_onClick) {
    TagName = 'button';
  }

  var thRoot = NavTag_themes_themes({
    colorActive: colorActive,
    colorUnactive: colorUnactive,
    isActive: isActive
  })[theme].thRoot;
  return __jsx(TagName, Object(esm_extends["a" /* default */])({
    "data-testid": "Tag" // $FlowFixMe

  }, rest, {
    className: classnames_default()(thRoot, className),
    onClick: function onClick(e) {
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      track();
    },
    href: href
  }, _onClick ? {
    type: href ? 'link' : 'button'
  } : null), children);
};

/***/ }),

/***/ "b0gt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("bWFh");
var collectionStrong = __webpack_require__("ZWaQ");

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "cVnM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Scrollable_Scrollable; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/feature-testing/index.js + 1 modules
var feature_testing = __webpack_require__("qlAI");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/scrollable/Scrollable.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var getNavPositionClasses = function getNavPositionClasses(navPosition) {
  switch (navPosition) {
    case 'top':
      return {
        thRoot: 'flex flex-col',
        thControlsWrapper: 'flex gap-10 justify-end mb-5 order-first w-full',
        thControls: 'flex gap-5 self-center',
        thControl: ''
      };

    case 'side':
      return {
        thRoot: 'flex flex-row justify-between',
        thInner: 'flex-1',
        thControlsWrapper: 'flex gap-10',
        thControls: 'flex gap-5 items-center justify-between pointer-events-none',
        thControl: 'mx-5',
        thControlDisabled: 'sr-only focus:not-sr-only',
        thControlLeft: 'pointer-events-auto mr-auto',
        thControlRight: 'pointer-events-auto ml-auto'
      };

    case 'center':
    default:
      return {
        thRoot: 'overflow-hidden relative',
        thControls: 'absolute flex items-center justify-between inset-0 pointer-events-none w-full z-1',
        thControl: 'mx-5',
        thControlDisabled: 'sr-only focus:not-sr-only',
        thControlLeft: 'pointer-events-auto mr-auto',
        thControlRight: 'pointer-events-auto ml-auto'
      };
  }
};

var themes = {
  "default": function _default(_ref) {
    var navPosition = _ref.navPosition;
    return _objectSpread(_objectSpread({}, getNavPositionClasses(navPosition)), {}, {
      thControlColor: colors["a" /* COLORS */].TRANSPARENT,
      thContolTheme: 'ghost',
      thControlSize: 23
    });
  },
  calendar: function calendar(_ref2) {
    var navPosition = _ref2.navPosition;
    return _objectSpread(_objectSpread({}, getNavPositionClasses(navPosition)), {}, {
      thInner: 'md:px-50',
      thControlColor: colors["a" /* COLORS */].WHITE,
      thControlSize: 46
    });
  },
  tabs: function tabs(_ref3) {
    var navPosition = _ref3.navPosition;
    return _objectSpread(_objectSpread({}, getNavPositionClasses(navPosition)), {}, {
      thControlColor: colors["a" /* COLORS */].LIGHT_SAND,
      thControlSize: 38
    });
  },
  nav: function nav() {
    return {
      thRoot: 'bg-white isolate overflow-hidden px-50 relative',
      thControls: 'absolute flex inset-0 items-center justify-between pointer-events-none w-full',
      thInner: 'border-lightGrey border-l-1 border-r-1',
      thControl: 'text-16',
      thControlLeft: 'mr-auto pointer-events-auto',
      thControlRight: 'ml-auto pointer-events-auto',
      thControlSize: 50,
      thControlColor: colors["a" /* COLORS */].TRANSPARENT,
      thContolTheme: 'ghost'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx










var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var WHEEL_DELTA_SCROLL_FACTOR = 50;
var CLICK_DELTA_SCROLL_FACTOR = 200;
var MOUSE_DELTA_SCROLL_FACTOR = 50;
var Scrollable_Scrollable = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Scrollable, _Component);

  var _super = _createSuper(Scrollable);

  function Scrollable(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Scrollable);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "scrollAreaNode", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "scrolling", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMouseWheel", function (e) {
      if (!_this.scrollAreaNode) {
        return;
      } // $FlowFixMe


      var wheelDelta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)); // $FlowFixMe

      _this.scrollAreaNode.scrollLeft -= wheelDelta * _this.props.deltaScrollFactorWheel; // Prevent page to scroll down

      if (_this.state.hasScrollLeft || _this.state.hasScrollRight) {
        e.preventDefault();
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onScroll", function () {
      var state = _this.processScroll();

      _this.setState(state);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMouseDown", function (direction) {
      return function () {
        if (!_this.scrollAreaNode) {
          return;
        }

        _this.scrolling = setInterval(function () {
          if (!_this.scrollAreaNode) {
            return;
          }

          _this.scrollAreaNode.scrollLeft += (_this.props.deltaScrollFactorMouse || MOUSE_DELTA_SCROLL_FACTOR) * direction;

          _this.onScroll();

          if (direction === -1 && !_this.state.hasScrollLeft || direction === 1 && !_this.state.hasScrollRight) {
            clearInterval(_this.scrolling);
          }
        }, 100);
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMouseUp", function () {
      clearInterval(_this.scrolling);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClick", function (direction) {
      return function () {
        if (!_this.scrollAreaNode) {
          return;
        }

        _this.scrollAreaNode.scrollLeft += (_this.props.deltaScrollFactorClick || CLICK_DELTA_SCROLL_FACTOR) * direction;

        _this.onScroll();
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setScrollAreaRef", function (ref) {
      _this.scrollAreaNode = ref;
    });

    _this.state = {
      hasScrollLeft: false,
      hasScrollRight: false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(Scrollable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.scrollAreaNode) {
        return;
      }

      if (this.props.hasNoMouseWheelScroll) {
        this.onScroll();
        return;
      }

      if (true) {
        // $FlowFixMe
        this.scrollAreaNode.addEventListener('scroll', this.onScroll, false); // $FlowFixMe

        this.scrollAreaNode.addEventListener('mousewheel', this.onMouseWheel, false); // $FlowFixMe

        this.scrollAreaNode.addEventListener('DOMMouseScroll', this.onMouseWheel, false); // Firefox

        this.onScroll();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.initialPosition !== this.props.initialPosition) {
        this.initScrollPosition();
      }

      var _this$processScroll = this.processScroll(),
          hasScrollLeft = _this$processScroll.hasScrollLeft,
          hasScrollRight = _this$processScroll.hasScrollRight;

      if (prevState.hasScrollRight !== hasScrollRight || prevState.hasScrollLeft !== hasScrollLeft) {
        this.setState({
          hasScrollLeft: hasScrollLeft,
          hasScrollRight: hasScrollRight
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.scrollAreaNode || this.props.hasNoMouseWheelScroll) {
        return;
      }

      if (true) {
        // $FlowFixMe
        this.scrollAreaNode.removeEventListener('scroll', this.onScroll, false); // $FlowFixMe

        this.scrollAreaNode.removeEventListener('mousewheel', this.onMouseWheel, false); // $FlowFixMe

        this.scrollAreaNode.removeEventListener('DOMMouseScroll', this.onMouseWheel, false);
      }
    }
  }, {
    key: "initScrollPosition",
    value: function initScrollPosition() {
      if (!this.scrollAreaNode) {
        return;
      }

      if (this.props.elementWidth && this.props.initialPosition) {
        var normalizedPosition = this.context.isRTL ? // $FlowFixMe
        -1 * this.props.initialPosition : this.props.initialPosition; // $FlowFixMe

        this.scrollAreaNode.scrollLeft = this.props.elementWidth * normalizedPosition;
      }
    }
  }, {
    key: "processScroll",
    value: function processScroll() {
      if (!this.scrollAreaNode) {
        return {
          hasScrollLeft: false,
          hasScrollRight: false
        };
      }

      var _this$scrollAreaNode = this.scrollAreaNode,
          scrollLeft = _this$scrollAreaNode.scrollLeft,
          clientWidth = _this$scrollAreaNode.clientWidth,
          scrollWidth = _this$scrollAreaNode.scrollWidth; // $FlowFixMe

      var isRTL = document.documentElement.dir === 'rtl';
      var hasScrollRight = isRTL ? scrollLeft < 0 : scrollLeft + clientWidth < scrollWidth; // the minus 1 is here to handle scroll correctly, I don't know where it came this pixel

      var hasScrollLeft = isRTL ? scrollLeft > -(scrollWidth - clientWidth - 1) : scrollLeft > 0;
      return {
        hasScrollLeft: hasScrollLeft,
        hasScrollRight: hasScrollRight
      };
    }
  }, {
    key: "shouldDisplayControls",
    value: function shouldDisplayControls() {
      var _this$state = this.state,
          hasScrollLeft = _this$state.hasScrollLeft,
          hasScrollRight = _this$state.hasScrollRight;
      var hasControlsOnTouch = this.props.hasControlsOnTouch;
      return (hasControlsOnTouch || !Object(feature_testing["a" /* hasTouch */])()) && (hasScrollLeft || hasScrollRight);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backwardLabel = _this$props.backwardLabel,
          children = _this$props.children,
          childrenWrapperClassNames = _this$props.childrenWrapperClassNames,
          className = _this$props.className,
          controlsClassName = _this$props.controlsClassName,
          forceDisplayControls = _this$props.forceDisplayControls,
          forwardLabel = _this$props.forwardLabel,
          header = _this$props.header,
          innerClassName = _this$props.innerClassName,
          navPosition = _this$props.navPosition,
          theme = _this$props.theme;

      if (!react["Children"].count(children)) {
        return null;
      }

      var _this$state2 = this.state,
          hasScrollLeft = _this$state2.hasScrollLeft,
          hasScrollRight = _this$state2.hasScrollRight;
      var isRTL = this.context.isRTL;

      var _themes$theme = themes[theme]({
        navPosition: navPosition
      }),
          thControl = _themes$theme.thControl,
          thControlColor = _themes$theme.thControlColor,
          thControlDisabled = _themes$theme.thControlDisabled,
          thControlLeft = _themes$theme.thControlLeft,
          thControlRight = _themes$theme.thControlRight,
          thControlSize = _themes$theme.thControlSize,
          thContolTheme = _themes$theme.thContolTheme,
          thControls = _themes$theme.thControls,
          thControlsWrapper = _themes$theme.thControlsWrapper,
          thInner = _themes$theme.thInner,
          thRoot = _themes$theme.thRoot;

      var hasControls = this.shouldDisplayControls() || forceDisplayControls;

      var rightScrollBtn = __jsx(ArrowButton["a" /* ArrowButton */], {
        className: classnames_default()(thControl, thControlRight, Object(defineProperty["a" /* default */])({}, thControlDisabled, !hasScrollRight)),
        color: thControlColor,
        hasNoRtl: true,
        isDisabled: !hasScrollRight,
        key: "right",
        label: forwardLabel,
        onClick: this.onClick(1),
        onMouseDown: this.onMouseDown(1),
        onMouseUp: this.onMouseUp,
        rotation: 180,
        size: thControlSize,
        theme: thContolTheme
      });

      var leftScrollBtn = __jsx(ArrowButton["a" /* ArrowButton */], {
        className: classnames_default()(thControl, thControlLeft, Object(defineProperty["a" /* default */])({}, thControlDisabled, !hasScrollLeft)),
        color: thControlColor,
        hasNoRtl: true,
        isDisabled: !hasScrollLeft,
        key: "left",
        label: backwardLabel,
        onClick: this.onClick(-1),
        onMouseDown: this.onMouseDown(-1),
        onMouseUp: this.onMouseUp,
        size: thControlSize,
        theme: thContolTheme
      });

      var scrollButtons = isRTL ? [rightScrollBtn, leftScrollBtn] : [leftScrollBtn, rightScrollBtn];
      return __jsx("div", {
        className: classnames_default()(thRoot, className),
        "data-testid": "scrollable"
      }, __jsx("div", {
        className: classnames_default()('overflow-hidden relative', innerClassName, thInner)
      }, __jsx("div", {
        className: classnames_default()(childrenWrapperClassNames, 'scrollbar-hidden scroll-smooth scroll-x tap-highlight-color-transparent'),
        ref: this.setScrollAreaRef
      }, children)), (hasControls || !!header) && __jsx("div", {
        className: thControlsWrapper
      }, header, hasControls && __jsx("div", {
        className: classnames_default()(controlsClassName, thControls),
        "data-testid": "Scrollable-controls"
      }, scrollButtons)));
    }
  }]);

  return Scrollable;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Scrollable_Scrollable, "contextType", ResponsiveContext["a" /* ResponsiveContext */]);

Object(defineProperty["a" /* default */])(Scrollable_Scrollable, "defaultProps", {
  children: null,
  deltaScrollFactorClick: CLICK_DELTA_SCROLL_FACTOR,
  deltaScrollFactorMouse: MOUSE_DELTA_SCROLL_FACTOR,
  deltaScrollFactorWheel: WHEEL_DELTA_SCROLL_FACTOR,
  elementWidth: 82,
  forceDisplayControls: false,
  hasControlsOnTouch: false,
  hasNoMouseWheelScroll: false,
  initialPosition: null,
  navPosition: 'center',
  theme: 'default'
});

/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "iiKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CheckedList_CheckedList; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/checked-list/CheckedList.themes.js

var themes = {
  "default": {
    thTitle: 'mb-20',
    thList: 'sm:columns-2 -m-5',
    thListItem: 'flex gap-10 p-5',
    thIcon: 'bg-green shrink-0 p-5 rounded-full',
    thIconColor: colors["a" /* COLORS */].WHITE,
    thIconWidth: '1.2em'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/checked-list/CheckedList.jsx

var __jsx = react_default.a.createElement;






var CheckedList_CheckedList = function CheckedList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      itemClassName = _ref.itemClassName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTitle = _themes$theme.thTitle,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thIcon = _themes$theme.thIcon,
      thIconColor = _themes$theme.thIconColor,
      thIconWidth = _themes$theme.thIconWidth;
  return __jsx(react["Fragment"], null, title && __jsx(Title["a" /* Title */], {
    className: thTitle,
    theme: "title-sans-n3"
  }, title), __jsx("ul", {
    className: classnames_default()(thList, className)
  }, react["Children"].map(children, function (child, idx) {
    return __jsx("li", {
      className: classnames_default()(itemClassName, thListItem),
      key: idx
    }, __jsx(Icon["a" /* Icon */], {
      color: thIconColor,
      className: thIcon,
      name: icons["a" /* ICONS */].CHECK,
      width: thIconWidth
    }), child);
  })));
};

/***/ }),

/***/ "nZ6J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export descriptors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getComponent; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4mDm");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Tskq");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5s+n");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PKPk");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3bBZ");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("hNT8");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("psNz");







 // const mod = ({ Component }) => Component;

var descriptors = new Map([
/* layout lines */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* PAGE_TRACKING */ "G"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(12), __webpack_require__.e(118)]).then(__webpack_require__.bind(null, "sLNG"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("sLNG")];
    },
    modules: ["./tracking/descriptor"]
  }
})],
/* common lines */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* ALL_INCLUSIVE_PUSH */ "a"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(170)]).then(__webpack_require__.bind(null, "DS8N"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("DS8N")];
    },
    modules: ["./all-inclusive-push/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* BRAND_PROMISE */ "b"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(162)]).then(__webpack_require__.bind(null, "WtX0"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("WtX0")];
    },
    modules: ["./brand-promise/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* BRAND_SUPERIORITY */ "c"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(36), __webpack_require__.e(169)]).then(__webpack_require__.bind(null, "JRrv"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("JRrv")];
    },
    modules: ["./brand-superiority/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* BUTTON_TICKET */ "d"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(186)]).then(__webpack_require__.bind(null, "ISYn"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ISYn")];
    },
    modules: ["./button-ticket/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* CHECKLIST */ "e"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(28), __webpack_require__.e(187)]).then(__webpack_require__.bind(null, "4LJ+"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("4LJ+")];
    },
    modules: ["./checklist/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* COMPARISON_TABLE */ "f"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(36), __webpack_require__.e(134)]).then(__webpack_require__.bind(null, "IjOA"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("IjOA")];
    },
    modules: ["./comparison-table/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* CRISIS_ALERT */ "g"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(163)]).then(__webpack_require__.bind(null, "3c8P"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("3c8P")];
    },
    modules: ["./crisis-alert/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* DESTINATIONS */ "j"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(138)]).then(__webpack_require__.bind(null, "UYKV"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("UYKV")];
    },
    modules: ["./destinations/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* DOWNLOAD_LINKS_LIST */ "k"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(171)]).then(__webpack_require__.bind(null, "yTkl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("yTkl")];
    },
    modules: ["./download-links-list/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EDITORIAL_FOLDING_BLOCK */ "l"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(153)]).then(__webpack_require__.bind(null, "ms+y"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ms+y")];
    },
    modules: ["./editorial-folding-block/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EVENT_ANIMATION */ "m"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(156)]).then(__webpack_require__.bind(null, "ddrH"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ddrH")];
    },
    modules: ["./event-animation/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EVENT_FORM */ "n"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(12), __webpack_require__.e(128)]).then(__webpack_require__.bind(null, "jvJq"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("jvJq")];
    },
    modules: ["./event-form/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* IMMERSIVE */ "s"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(199)]).then(__webpack_require__.bind(null, "RgPE"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("RgPE")];
    },
    modules: ["./immersive/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* INSPIRATIONAL_GRID */ "t"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, "3Fn9"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("3Fn9")];
    },
    modules: ["./inspirational-grid/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* LAST_SEEN_PRODUCTS */ "u"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(29), __webpack_require__.e(140)]).then(__webpack_require__.bind(null, "Qdj2"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Qdj2")];
    },
    modules: ["./last-seen-products/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MEDIA_TEXT_HORIZONTAL */ "v"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(147)]).then(__webpack_require__.bind(null, "xoIU"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("xoIU")];
    },
    modules: ["./media-text-horizontal/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MEDIA_TEXT_VERTICAL */ "w"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(148)]).then(__webpack_require__.bind(null, "jyQO"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("jyQO")];
    },
    modules: ["./media-text-vertical/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MEDIA_THUMBNAIL */ "x"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(145)]).then(__webpack_require__.bind(null, "YWPa"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("YWPa")];
    },
    modules: ["./media-thumbnail/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* NAVIGATION_TAB */ "z"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 202).then(__webpack_require__.bind(null, "Q52w"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Q52w")];
    },
    modules: ["./navigation-tab/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* NAVIGATION_TABS */ "A"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(123)]).then(__webpack_require__.bind(null, "LNeH"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("LNeH")];
    },
    modules: ["./navigation-tabs/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFERS_GRID */ "B"], function () {
  return next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(141)]).then(__webpack_require__.bind(null, "wqTy"));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/("wqTy")];
      },
      modules: ["./offers-grid/descriptor"]
    }
  });
}], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFERS_PUSH */ "C"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(150)]).then(__webpack_require__.bind(null, "A3qt"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("A3qt")];
    },
    modules: ["./offers-push/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PREBOOKING_FORM */ "H"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(12), __webpack_require__.e(127)]).then(__webpack_require__.bind(null, "1w3z"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("1w3z")];
    },
    modules: ["./prebooking-form/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_TAGS */ "U"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(137)]).then(__webpack_require__.bind(null, "KQqJ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("KQqJ")];
    },
    modules: ["./product-tags/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCTS_FILTERS */ "I"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(12), __webpack_require__.e(121)]).then(__webpack_require__.bind(null, "s++G"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("s++G")];
    },
    modules: ["./products-filters/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_GRID */ "jb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(12), __webpack_require__.e(120)]).then(__webpack_require__.bind(null, "bNOZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("bNOZ")];
    },
    modules: ["./products-grid/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SECTION */ "vb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 254).then(__webpack_require__.bind(null, "0BFP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("0BFP")];
    },
    modules: ["./section/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SECTIONS */ "wb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(28), __webpack_require__.e(255)]).then(__webpack_require__.bind(null, "qsa7"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("qsa7")];
    },
    modules: ["./sections/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SMART_FAQ */ "xb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 257).then(__webpack_require__.bind(null, "+2Bl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("+2Bl")];
    },
    modules: ["./smart-faq/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SUBMISSION_STATUS */ "yb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(182)]).then(__webpack_require__.bind(null, "FQba"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("FQba")];
    },
    modules: ["./submission-status/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TAB */ "zb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 258).then(__webpack_require__.bind(null, "mM3U"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("mM3U")];
    },
    modules: ["./tab/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TABS */ "Ab"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(142)]).then(__webpack_require__.bind(null, "B07w"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("B07w")];
    },
    modules: ["./tabs/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TEASER_CARDS */ "Bb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(133)]).then(__webpack_require__.bind(null, "6DS4"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("6DS4")];
    },
    modules: ["./teaser-cards/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TEST_AB */ "Cb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 165).then(__webpack_require__.bind(null, "O94t"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("O94t")];
    },
    modules: ["./test-ab/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TEXT */ "Db"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(260)]).then(__webpack_require__.bind(null, "dJAn"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("dJAn")];
    },
    modules: ["./text/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* THEMATIC */ "Eb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(166)]).then(__webpack_require__.bind(null, "TgTY"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("TgTY")];
    },
    modules: ["./thematic/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TITLE_AND_TEXT */ "Fb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(160)]).then(__webpack_require__.bind(null, "aMVx"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("aMVx")];
    },
    modules: ["./title-and-text/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TRAVEL_RESTRICTIONS */ "Jb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(39), __webpack_require__.e(154)]).then(__webpack_require__.bind(null, "T5EZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("T5EZ")];
    },
    modules: ["./travel-restrictions/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TRIPADVISOR_TESTIMONY */ "Kb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(161)]).then(__webpack_require__.bind(null, "GSMs"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("GSMs")];
    },
    modules: ["./tripadvisor-testimony/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* VIDEO */ "Lb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(167)]).then(__webpack_require__.bind(null, "K7yN"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("K7yN")];
    },
    modules: ["./video/descriptor"]
  }
})],
/* home lines : homepage recommended */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* HIGHLIGHT */ "r"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(198)]).then(__webpack_require__.bind(null, "+nt3"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("+nt3")];
    },
    modules: ["./highlight/descriptor"]
  }
})],
/* offer lines : offerId needed */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFER_DESCRIPTION */ "D"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(157)]).then(__webpack_require__.bind(null, "wq1+"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("wq1+")];
    },
    modules: ["./offer-description/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFER_LEGAL_INFORMATION */ "E"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(175)]).then(__webpack_require__.bind(null, "Z6pd"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Z6pd")];
    },
    modules: ["./offer-legal-information/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFER_SEO */ "F"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 206).then(__webpack_require__.bind(null, "7YIZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("7YIZ")];
    },
    modules: ["./offer-seo/descriptor"]
  }
})],
/* cruise lines : resortId/productId needed (only cruise ID) */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* CRUISE_BOOKING */ "h"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(132)]).then(__webpack_require__.bind(null, "oD44"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("oD44")];
    },
    modules: ["./cruise-booking/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* CRUISE_PROGRAM */ "i"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(190)]).then(__webpack_require__.bind(null, "NTfX"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("NTfX")];
    },
    modules: ["./cruise-program/descriptor"]
  }
})], // no ID needed but commonly on cruise page

/* product lines : resortId/productId needed */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* EXCLUSIVE_COLLECTION_SPACE */ "o"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(174)]).then(__webpack_require__.bind(null, "26Xc"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("26Xc")];
    },
    modules: ["./exclusive-collection-space/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EXCLUSIVE_COLLECTION_SPACE_INTRODUCTION */ "p"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(173)]).then(__webpack_require__.bind(null, "eiEl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("eiEl")];
    },
    modules: ["./exclusive-collection-space-introduction/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* HAPPY_TO_CARE */ "q"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(39), __webpack_require__.e(196)]).then(__webpack_require__.bind(null, "JxsF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("JxsF")];
    },
    modules: ["./happy-to-care/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_ACCESS_AND_MAP */ "bb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(176)]).then(__webpack_require__.bind(null, "Je/+"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Je/+")];
    },
    modules: ["./product-access-and-map/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_ACCOMMODATION_TYPES */ "db"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(130)]).then(__webpack_require__.bind(null, "m1uF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("m1uF")];
    },
    modules: ["./product-accommodations/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION */ "cb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(129)]).then(__webpack_require__.bind(null, "Kbtl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Kbtl")];
    },
    modules: ["./product-accommodations-exclusive/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_ACTIVITIES */ "J"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(12), __webpack_require__.e(117)]).then(__webpack_require__.bind(null, "GSnJ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("GSnJ")];
    },
    modules: ["./product-activities/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_BARS */ "eb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(212)]).then(__webpack_require__.bind(null, "TFik"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("TFik")];
    },
    modules: ["./product-bars/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_BOOKING_BE */ "fb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(12), __webpack_require__.e(119)]).then(__webpack_require__.bind(null, "EgjI"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("EgjI")];
    },
    modules: ["./product-booking/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_BREADCRUMB */ "K"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(215)]).then(__webpack_require__.bind(null, "gfEP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("gfEP")];
    },
    modules: ["./product-breadcrumb/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_CHILDCARES */ "L"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(131)]).then(__webpack_require__.bind(null, "uvus"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("uvus")];
    },
    modules: ["./product-childcares/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_DESTINATION */ "gb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(37), __webpack_require__.e(158)]).then(__webpack_require__.bind(null, "Smcz"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Smcz")];
    },
    modules: ["./product-destination/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_DISTRICT */ "hb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(253)]).then(__webpack_require__.bind(null, "YkGc"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("YkGc")];
    },
    modules: ["./resort-district/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_FLASH_INFO */ "ib"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(149)]).then(__webpack_require__.bind(null, "1Ak6"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("1Ak6")];
    },
    modules: ["./product-flash-info/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_STREET_VIEW */ "S"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(219)]).then(__webpack_require__.bind(null, "yWVM"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("yWVM")];
    },
    modules: ["./product-google-street-view/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_IMAGE_MAP */ "M"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(179)]).then(__webpack_require__.bind(null, "YY1v"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("YY1v")];
    },
    modules: ["./product-image-map/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_IMMERSIVE */ "N"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(143)]).then(__webpack_require__.bind(null, "Nn0M"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Nn0M")];
    },
    modules: ["./product-immersive/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_INFORMATION_SUMMARY */ "O"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(180)]).then(__webpack_require__.bind(null, "PeCK"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("PeCK")];
    },
    modules: ["./product-information-summary/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_INTRODUCTION */ "kb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(31), __webpack_require__.e(139)]).then(__webpack_require__.bind(null, "3cys"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("3cys")];
    },
    modules: ["./product-introduction/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_MEETING_ROOM_INFO */ "lb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(225)]).then(__webpack_require__.bind(null, "DnnJ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("DnnJ")];
    },
    modules: ["./product-meeting-room-info/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_MULTIMEDIA */ "mb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(144)]).then(__webpack_require__.bind(null, "mxuP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("mxuP")];
    },
    modules: ["./product-multimedia/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MUST_TRY_EXPERIENCES */ "y"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(164)]).then(__webpack_require__.bind(null, "wvxA"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("wvxA")];
    },
    modules: ["./product-must-try-experiences/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_PRICE_REMOTE */ "nb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(12), __webpack_require__.e(116)]).then(__webpack_require__.bind(null, "FLWE"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("FLWE")];
    },
    modules: ["./product-price-remote/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_PRICE_TICKET */ "ob"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(232)]).then(__webpack_require__.bind(null, "eGWY"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("eGWY")];
    },
    modules: ["./product-price-ticket/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_PRICE_TICKET_CUSTOM */ "P"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(230)]).then(__webpack_require__.bind(null, "S5GU"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("S5GU")];
    },
    modules: ["./product-price-ticket-custom/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QRCODE_PRODUCT_BARS */ "V"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(251)]).then(__webpack_require__.bind(null, "cmoa"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("cmoa")];
    },
    modules: ["./qrcode-product-bars/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QRCODE_PRODUCT_DRESSCODE */ "W"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(135)]).then(__webpack_require__.bind(null, "zyV9"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("zyV9")];
    },
    modules: ["./qrcode-product-dresscode/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QRCODE_PRODUCT_PROGRAM */ "X"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(136)]).then(__webpack_require__.bind(null, "vLcP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("vLcP")];
    },
    modules: ["./qrcode-product-program/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QRCODE_PRODUCT_RESTAURANTS */ "Y"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(252)]).then(__webpack_require__.bind(null, "tjsQ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("tjsQ")];
    },
    modules: ["./qrcode-product-restaurants/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QUOTATION_FORM */ "Z"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(12), __webpack_require__.e(126)]).then(__webpack_require__.bind(null, "bpGR"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("bpGR")];
    },
    modules: ["./product-quotation-form/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_RECOMMENDATIONS */ "pb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(29), __webpack_require__.e(146)]).then(__webpack_require__.bind(null, "qmxF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("qmxF")];
    },
    modules: ["./product-recommendations/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RELATED_PRODUCTS */ "ab"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(236)]).then(__webpack_require__.bind(null, "CSWM"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("CSWM")];
    },
    modules: ["./product-related-products/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_RESTAURANTS */ "qb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(238)]).then(__webpack_require__.bind(null, "08wu"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("08wu")];
    },
    modules: ["./product-restaurants/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_SEO */ "rb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 240).then(__webpack_require__.bind(null, "CS9y"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("CS9y")];
    },
    modules: ["./product-seo-title/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_SERVICES */ "Q"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(152)]).then(__webpack_require__.bind(null, "Z4cC"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Z4cC")];
    },
    modules: ["./product-services/descriptor"]
  }
})], // no ID but commonly on product page
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_SIGNATURES */ "R"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(243)]).then(__webpack_require__.bind(null, "flGr"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("flGr")];
    },
    modules: ["./product-signatures/descriptor"]
  }
})], // no ID but commonly on product page
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_STRENGTHS */ "T"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(244)]).then(__webpack_require__.bind(null, "0a2G"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("0a2G")];
    },
    modules: ["./product-strengths/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_SUMMARY */ "sb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(246)]).then(__webpack_require__.bind(null, "/rmy"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("/rmy")];
    },
    modules: ["./product-summary/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_TRIPADVISOR */ "ub"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(155)]).then(__webpack_require__.bind(null, "G5yF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("G5yF")];
    },
    modules: ["./product-tripadvisor/descriptor"]
  }
})],
/* tour lines : resortId/productId needed (only tour ID) */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* TOUR_INTRODUCTION */ "Gb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(263)]).then(__webpack_require__.bind(null, "LQjd"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("LQjd")];
    },
    modules: ["./tour-introduction/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TOUR_PRACTICAL_INFORMATION */ "Hb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(265)]).then(__webpack_require__.bind(null, "9xag"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("9xag")];
    },
    modules: ["./tour-practical-information/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TOUR_PROGRAM */ "Ib"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(267)]).then(__webpack_require__.bind(null, "cKQV"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("cKQV")];
    },
    modules: ["./tour-program/descriptor"]
  }
})]]);
var hasComponent = function hasComponent(name) {
  return descriptors.has(name);
};
var getComponent = function getComponent(name) {
  if (!descriptors.has(name)) {
    return null;
  }

  return descriptors.get(name);
};

/***/ }),

/***/ "oG87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SuFq");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("aPQG");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("igjW");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var ErrorBoundaryComponent = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(ErrorBoundaryComponent, _React$Component);

  var _super = _createSuper(ErrorBoundaryComponent);

  function ErrorBoundaryComponent(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, ErrorBoundaryComponent);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(ErrorBoundaryComponent, [{
    key: "componentDidCatch",
    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error, info) {
      Object(_errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_12__[/* handleComponentError */ "a"])(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          router = _this$props.router,
          children = _this$props.children;

      if (this.state.hasError) {
        if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_13__[/* isStrictlyProductionEnv */ "f"])()) {
          var locale = router.query.locale;
          router.replace({
            pathname: '/500',
            query: Boolean(locale) && {
              locale: locale
            }
          });
          this.setState({
            hasError: false
          });
        }

        return null;
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundaryComponent;
}(react__WEBPACK_IMPORTED_MODULE_10___default.a.Component);

var ErrorBoundary = Object(next_router__WEBPACK_IMPORTED_MODULE_11__["withRouter"])(ErrorBoundaryComponent);

/***/ }),

/***/ "tCJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Sections_Sections; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("qePV");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// CONCATENATED MODULE: ./src/client/components/frameworks/intersection-observer/createIntersectionObserver.js
if (true) {
  // Polyfills for intersection-observer
  __webpack_require__("LNcM");
}

function createIntersectionObserver(callback, options) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  return new IntersectionObserver(callback, options);
}
// CONCATENATED MODULE: ./src/client/components/frameworks/intersection-observer/IntersectionObserver.jsx













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var IntersectionObserver_IntersectionObserver = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(IntersectionObserver, _Component);

  var _super = _createSuper(IntersectionObserver);

  function IntersectionObserver() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, IntersectionObserver);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleIntersection", function (_ref) {
      var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 1),
          entry = _ref2[0];

      _this.props.onChange(entry);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "observe", function () {
      if (_this.target && _this.observer) {
        _this.observer.observe(_this.target);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "unobserve", function () {
      if (_this.target && _this.observer) {
        _this.observer.unobserve(_this.target);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setRefTarget", function (target) {
      _this.targetChanged = _this.previousTarget && _this.previousTarget !== target;

      if (_this.targetChanged) {
        _this.unobserve();
      }

      _this.target = target;
    });

    return _this;
  }

  Object(createClass["a" /* default */])(IntersectionObserver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          rootMargin = _this$props.rootMargin,
          threshold = _this$props.threshold;
      this.observer = createIntersectionObserver(this.handleIntersection, {
        rootMargin: rootMargin,
        threshold: threshold
      });
      this.observe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unobserve();

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      // @todo remove this
      this.previousTarget = this.target;
      return /*#__PURE__*/react_default.a.cloneElement(react_default.a.Children.only(this.props.children), {
        ref: this.setRefTarget
      });
    }
  }]);

  return IntersectionObserver;
}(react["Component"]);

Object(defineProperty["a" /* default */])(IntersectionObserver_IntersectionObserver, "displayName", 'IntersectionObserver');

Object(defineProperty["a" /* default */])(IntersectionObserver_IntersectionObserver, "defaultProps", {
  rootMargin: '0px',
  threshold: 0
});
// CONCATENATED MODULE: ./src/client/components/frameworks/section/Section.jsx











var __jsx = react_default.a.createElement;

function Section_createSuper(Derived) { var hasNativeReflectConstruct = Section_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Section_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var Section_Section = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(Section, _PureComponent);

  var _super = Section_createSuper(Section);

  function Section(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Section);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "intersectionObserverThreshold", void 0);

    _this.intersectionObserverThreshold = [];

    for (var i = 0; i <= 1.0; i += 0.01) {
      // Get notified of every percent of visiblity change in the viewport (1% of intersection to 100%)
      _this.intersectionObserverThreshold.push(Math.round(i * 100) / 100);
    }

    return _this;
  }

  Object(createClass["a" /* default */])(Section, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          index = _this$props.index,
          name = _this$props.name;
      var anchor = name ? dist["url"].normalizeSlug(name) : null;
      return __jsx(IntersectionObserver_IntersectionObserver, {
        onChange: this.props.onSectionIntersectViewport,
        threshold: this.intersectionObserverThreshold
      }, __jsx("section", {
        className: className,
        "data-cs-override-id": "Section",
        "data-index": index,
        "data-testid": "section",
        id: anchor || null
      }, children));
    }
  }]);

  return Section;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(Section_Section, "defaultProps", {
  name: ''
});
// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/nav-tag/NavTag.jsx + 1 modules
var NavTag = __webpack_require__("UXOF");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// CONCATENATED MODULE: ./src/client/components/frameworks/sections/Sections.jsx





var Sections_jsx = react_default.a.createElement;








var Sections_Sections = function Sections(_ref) {
  var children = _ref.children,
      className = _ref.className,
      navItems = _ref.navItems,
      getTrackingData = _ref.getTrackingData,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel,
      pageType = _ref.pageType;
  var track = Object(useTracking["a" /* useTracking */])();
  var navBarRef = Object(react["useRef"])(null);
  var onSectionIntersectViewport = Object(react["useRef"])(noop_default.a);

  var _useState = Object(react["useState"])(0),
      selectedIndex = _useState[0],
      setSelectedIndex = _useState[1];

  var navSelector = pageType || 'Sections'; // eslint-disable-next-line no-unused-vars

  var _useState2 = Object(react["useState"])(false),
      isSticky = _useState2[0],
      setIsSticky = _useState2[1];

  var onNavItemClick = Object(react["useCallback"])(function (anchor, index, label) {
    return function (e) {
      e.preventDefault(); // $FlowFixMe

      var selected = Number(index);
      var scrollRootOffsetSelector = "#".concat(navSelector);

      if (getTrackingData) {
        track(getTrackingData(label));
      }

      Object(scrollToElement["a" /* scrollToElement */])("#".concat(anchor), 600, scrollRootOffsetSelector).then(function () {
        setSelectedIndex(selected);
      });
    };
  }, []);
  var navbarItems = Object(react["useMemo"])(function () {
    return navItems.map(function (label, index) {
      var anchor = label ? dist["url"].normalizeSlug(label) : '';
      return {
        href: "#".concat(anchor),
        label: label,
        onClick: anchor ? onNavItemClick(anchor, index, label) : noop_default.a
      };
    });
  }, [navItems]);
  Object(react["useEffect"])(function () {
    if (!isSticky) {
      setSelectedIndex(0);
    }
  }, [isSticky]);
  Object(react["useEffect"])(function () {
    onSectionIntersectViewport.current = function (event) {
      var visiblePercentage = Math.floor(event.intersectionRatio * 100);

      var navBarHeight = navBarRef && get_default()(navBarRef, 'current.offsetHeight');

      var selected = Number(event.target.dataset.index);

      if (event.isIntersecting && visiblePercentage > 10 && event.intersectionRect.top <= navBarHeight) {
        setSelectedIndex(selected);
      }
    };
  }, []);
  Object(react["useEffect"])(function () {
    var element = navBarRef.current;
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 1),
          e = _ref3[0];

      return setIsSticky(e.intersectionRatio < 1);
    }, {
      threshold: [1]
    });

    if (element) {
      observer.observe(element);
      return function () {
        return observer.unobserve(element);
      };
    }
  }, [navBarRef]);
  return Sections_jsx("div", {
    className: className
  }, Sections_jsx("div", {
    ref: navBarRef,
    id: navSelector,
    className: classnames_default()('flex bg-white sticky flex-wrap w-full mx-auto -top-1', {
      'border-b-1 z-8': isSticky
    })
  }, Sections_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: scrollBackwardLabel,
    childrenWrapperClassNames: "flex gap-10",
    className: "max-w-site py-10 bg-white lg:mx-auto w-full",
    forceDisplayControls: true,
    forwardLabel: scrollForwardLabel
  }, navbarItems.map(function (item, index) {
    return Sections_jsx(NavTag["a" /* NavTag */], {
      href: item.href,
      isActive: index === selectedIndex,
      key: item.label,
      onClick: item.onClick
    }, item.label);
  }))), react["Children"].map(children, function (section, index) {
    return Sections_jsx(Section_Section, {
      index: index,
      key: navItems[index],
      name: navItems[index],
      onSectionIntersectViewport: onSectionIntersectViewport.current
    }, section);
  }));
};
Sections_Sections.defaultProps = {
  children: [],
  navItems: [],
  pageType: ''
};

/***/ }),

/***/ "ybtA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return Line; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("zytj");
/* harmony import */ var _context_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("oG87");
/* harmony import */ var _cms_toolkit_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nZ6J");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;




var Line = function Line(_ref) {
  var dataTestIdPrefix = _ref.dataTestIdPrefix,
      id = _ref.id,
      name = _ref.name,
      component = _ref.component,
      _ref$pageLines = _ref.pageLines,
      pageLines = _ref$pageLines === void 0 ? [] : _ref$pageLines,
      _ref$props = _ref.props,
      _ref$props$lines = _ref$props.lines,
      lines = _ref$props$lines === void 0 ? [] : _ref$props$lines,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_ref$props, ["lines"]);

  if (!component && !Object(_cms_toolkit_descriptors__WEBPACK_IMPORTED_MODULE_8__[/* hasComponent */ "b"])(name) && lines.length === 0) {
    _logger_logger__WEBPACK_IMPORTED_MODULE_6__["default"].warn("Line without Component ".concat(String(id), " / ").concat(String(name)));
    return null;
  }

  var Component = component || Object(_cms_toolkit_descriptors__WEBPACK_IMPORTED_MODULE_8__[/* getComponent */ "a"])(name);

  if (Component) {
    return __jsx(_context_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__[/* ErrorBoundary */ "a"], {
      key: id
    }, __jsx(Component, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, props, {
      dataTestIdPrefix: dataTestIdPrefix,
      lines: lines,
      pageLines: pageLines
    }), lines.map(function (line) {
      return __jsx(Line, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, line, {
        dataTestIdPrefix: dataTestIdPrefix,
        key: line.id,
        pageLines: pageLines
      }));
    })));
  }

  return __jsx(_context_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__[/* ErrorBoundary */ "a"], {
    key: id
  }, lines.map(function (line) {
    return __jsx(Line, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, line, {
      dataTestIdPrefix: dataTestIdPrefix,
      key: line.id,
      pageLines: pageLines
    }));
  }));
};

/***/ })

}]);